<div [formGroup]="form" class="row">
  <div class="col-12 form-group">
    <label for="folderName" class="control-label">
      <b>{{ 'folderStructure.newFolder' | translate }}</b>
    </label>
    <p>{{ 'folderStructure.instructions' | translate }}</p>
    <div class="input-group">
      <input
        formControlName="folderName"
        id="folderName"
        class="form-control"
        [name]="'folderStructure.newFolder' | translate"
        [placeholder]="'folderStructure.placeholder' | translate"
        (keydown)="preventInvalid('folderName', $event)"
      />
    </div>
    <div
      *ngIf="
        (form.get('folderName').touched && form.get('folderName').invalid) ||
        showInvalid
      "
      class="text-danger mx-1"
    >
      {{ 'folderStructure.patternError' | translate }}
    </div>
  </div>
</div>
